import { actionType } from './typeAction';
import { endpoint } from '../../api/endpoint';
import { ApiWrapper } from '../../api/fatchApi';

// HOME PAGE
export const GetMoviesHome = () => async dispatch => {
    const options = { url: endpoint.trendingmovies}
    const types = { request: actionType.FET_MOVIE_HOME_REQUEST, success: actionType.FET_MOVIE_HOME, failed: actionType.FET_MOVIE_HOME_FAILED}
    dispatch(ApiWrapper({ options, types }))
}
// NOVBAR
export const  Get_Catagory = (Getgotagoray, currentPage) => async dispatch => {
    const options = { url: endpoint.genremovies + Getgotagoray + '&page=' + currentPage }
    const types = { request: actionType.FET_GENRE_REQUEST, success: actionType.FET_GENRE, failed: actionType.FET_GENRE_FAILED}
    dispatch(ApiWrapper({ options, types }))
}

// SEARCH MOVIE
export const SearchMovies = (search) => async dispatch => {
    const options = { url: endpoint.searchmovies + search }
    const types = { request: actionType.SEARCH_MOVIES_REQUEST, success: actionType.SEARCH_MOVIES, failed: actionType.SEARCH_FAILED }
    dispatch(ApiWrapper({ options, types }))
}

// DETAIL MOVIES
export const FetMovieDetail = (moviesId) => async dispatch => {
    const options = { url: endpoint.detailmovies + moviesId }
    const types = { request: actionType.SELECTED_MOVIES_REQUEST, success: actionType.SELECTED_MOVIES, failed: actionType.SELECTED_FAILED }
    dispatch(ApiWrapper({ options, types }))
}
// SIMILAR MOVIES
export const FetMovieSimilar = (moviesId) => async dispatch => {
    const options = { url: endpoint.similarmovies + moviesId }
    const types = { request: actionType.SIMILAR_MOVIES_REQUEST, success: actionType.SIMILAR_MOVIES_SUCCESS, failed: actionType.SIMILAR_MOVIES_FAILED}
    dispatch(ApiWrapper({ options, types }))
}
// BROWSE MOVIES
export const FetBrowserMovies = (searchterm, quality, gerne, rating, year, language, orderby) => async dispatch => {
    const options = { url: endpoint.browsermovies+'query_term='+searchterm+'&quality='+quality+'&minimum_rating='+rating+'&genre='+gerne+'&sort_by='+language+'&sort_by='+orderby+'sort_by='+year}
    const types = { request: actionType.BROWSE_MOVIES_REQUEST, success: actionType.BROWSE_MOVIES_SUCCESS, failed: actionType.BROWSE_MOVIES_FAILED}
    dispatch(ApiWrapper({ options, types }))
}
export const removeMovie = () => {
    return {
        type: actionType.REMOVE_MOVIE,
    }
}
export const removeBrowse =()=>{
    return {
        type: actionType.BROWSE_MOVIES_REMOVE
    }
}